import React from 'react';

const BestsellersReport = ({ bestsellingProducts, reportParams, setReportParams, loadBestsellingProducts }) => {
  return (
    <div>
      <div>
        <div style={{ border: '1px solid var(--border)', borderRadius: '0.375rem', backgroundColor: 'var(--card-bg)' }}>
          <div style={{ padding: '0.5rem', backgroundColor: 'var(--bg)', borderBottom: '1px solid var(--border)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h5 style={{ margin: 0, fontSize: '0.9rem', fontWeight: '600' }}>🏆 Bestsellery - Top {reportParams.limit} produktów</h5>
              <select
                style={{
                  padding: '6px 10px',
                  fontSize: '12px',
                  border: '1px solid var(--border)',
                  borderRadius: '6px',
                  backgroundColor: 'var(--card-bg)',
                  color: 'var(--text)'
                }}
                value={reportParams.metric}
                onChange={(e) => {
                  const newParams = {...reportParams, metric: e.target.value};
                  setReportParams(newParams);
                  loadBestsellingProducts(newParams);
                }}
              >
                <option value="quantity">Według ilości</option>
                <option value="revenue">Według przychodu</option>
              </select>
            </div>
          </div>
          <div style={{ padding: '0.75rem' }}>
            {bestsellingProducts.products?.length > 0 ? (
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.7rem' }}>
                  <thead>
                    <tr>
                      <th style={{ padding: '0.3rem', borderBottom: '1px solid var(--border)', textAlign: 'left', fontSize: '0.65rem' }}>Ranking</th>
                      <th style={{ padding: '0.3rem', borderBottom: '1px solid var(--border)', textAlign: 'left', fontSize: '0.65rem' }}>Produkt</th>
                      <th style={{ padding: '0.3rem', borderBottom: '1px solid var(--border)', textAlign: 'left', fontSize: '0.65rem' }}>Producent</th>
                      <th style={{ padding: '0.3rem', borderBottom: '1px solid var(--border)', textAlign: 'left', fontSize: '0.65rem' }}>Ilość</th>
                      <th style={{ padding: '0.3rem', borderBottom: '1px solid var(--border)', textAlign: 'left', fontSize: '0.65rem' }}>Przychód</th>
                      <th style={{ padding: '0.3rem', borderBottom: '1px solid var(--border)', textAlign: 'left', fontSize: '0.65rem' }}>Śr. cena</th>
                      <th style={{ padding: '0.3rem', borderBottom: '1px solid var(--border)', textAlign: 'left', fontSize: '0.65rem' }}>Trans.</th>
                      <th style={{ padding: '0.3rem', borderBottom: '1px solid var(--border)', textAlign: 'left', fontSize: '0.65rem' }}>%</th>
                      <th style={{ padding: '0.3rem', borderBottom: '1px solid var(--border)', textAlign: 'left', fontSize: '0.65rem' }}>Trend</th>
                    </tr>
                  </thead>
                  <tbody>
                    {bestsellingProducts.products.map((product) => (
                      <tr key={product.id}>
                        <td style={{ padding: '0.25rem', borderBottom: '1px solid var(--bg)' }}>
                          <span style={{
                            backgroundColor: product.ranking <= 3 ? 'var(--warning)' :
                              product.ranking <= 10 ? 'var(--info)' : 'var(--text-muted)',
                            color: '#fff' ,
                            padding: '0.1rem 0.25rem',
                            borderRadius: '0.2rem',
                            fontSize: '0.6rem'
                          }}>
                            #{product.ranking}
                          </span>
                        </td>
                        <td style={{ padding: '0.25rem', borderBottom: '1px solid var(--bg)' }}>
                          <div>
                            <div style={{ fontWeight: '600', fontSize: '0.65rem' }}>{product.nazwa}</div>
                            <div style={{ color: 'var(--text-muted)', fontSize: '0.6rem' }}>{product.kod_produktu}</div>
                          </div>
                        </td>
                        <td style={{ padding: '0.25rem', borderBottom: '1px solid var(--bg)' }}>{product.producent_nazwa || '-'}</td>
                        <td style={{ padding: '0.25rem', borderBottom: '1px solid var(--bg)' }}>{product.total_quantity_sold}</td>
                        <td style={{ padding: '0.25rem', borderBottom: '1px solid var(--bg)' }}>{parseFloat(product.total_revenue || 0).toFixed(2)} zł</td>
                        <td style={{ padding: '0.25rem', borderBottom: '1px solid var(--bg)' }}>{parseFloat(product.avg_price || 0).toFixed(2)} zł</td>
                        <td style={{ padding: '0.25rem', borderBottom: '1px solid var(--bg)' }}>{product.transactions_count}</td>
                        <td style={{ padding: '0.25rem', borderBottom: '1px solid var(--bg)' }}>
                          <span style={{
                            border: '1px solid var(--info)', color: 'var(--info)' ,
                            padding: '0.1rem 0.2rem',
                            borderRadius: '0.2rem',
                            fontSize: '0.6rem'
                          }}>
                            {reportParams.metric === 'quantity'
                              ? parseFloat(product.percentage_of_total_quantity || 0).toFixed(1)
                              : parseFloat(product.percentage_of_total_revenue || 0).toFixed(1)
                            }%
                          </span>
                        </td>
                        <td style={{ padding: '0.25rem', borderBottom: '1px solid var(--bg)' }}>
                          <span style={{
                            backgroundColor: product.trend === 'Wysoka' ? 'var(--success)' :
                              product.trend === 'Średnia' ? 'var(--warning)' : 'var(--text-muted)',
                            color: '#fff' ,
                            padding: '0.1rem 0.2rem',
                            borderRadius: '0.2rem',
                            fontSize: '0.6rem'
                          }}>
                            {product.trend}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div style={{ textAlign: 'center', color: 'var(--text-muted)', fontSize: '0.8rem' }}>Brak danych</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BestsellersReport;
